import { render, staticRenderFns } from "./CompTabelaCartasAssinatura.vue?vue&type=template&id=3f44a12e&scoped=true&"
import script from "./CompTabelaCartasAssinatura.vue?vue&type=script&lang=js&"
export * from "./CompTabelaCartasAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaCartasAssinatura.vue?vue&type=style&index=0&id=3f44a12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f44a12e",
  null
  
)

export default component.exports